import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import { applyCSP } from './utils/securityUtils';
import { prepareShopifyCheckout } from './utils/shopifyCheckout';

// Apply CSP immediately before any API calls
applyCSP();

// Setup Shopify checkout interceptor for shop.app requests
prepareShopifyCheckout();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Router>
      <GlobalStyles />
      <App />
    </Router>
  </React.StrictMode>
);
